import { render } from "./LogsDialog.vue?vue&type=template&id=46d96c84&scoped=true&ts=true"
import script from "./LogsDialog.vue?vue&type=script&lang=ts"
export * from "./LogsDialog.vue?vue&type=script&lang=ts"

import "./LogsDialog.vue?vue&type=style&index=0&id=46d96c84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d96c84"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QBar,QSpace,QBtn,QCardSection});
